/**
 * Firebase App Check bootstrap for Passport SPA (A4 monitor-only).
 */
import type { FirebaseApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import {
  getFirebaseAppCheckDebugToken,
  getFirebaseAppCheckRecaptchaSiteKey,
  isFirebaseAppCheckConfigured,
} from '../constants/appCheck';

let appCheckInitialized = false;

export function initFirebaseAppCheck(app: FirebaseApp): void {
  if (appCheckInitialized || typeof window === 'undefined') {
    return;
  }

  if (!isFirebaseAppCheckConfigured()) {
    if (import.meta.env.DEV) {
      console.info('[Passport AppCheck] Skipped — VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY not set');
    }
    return;
  }

  const siteKey = getFirebaseAppCheckRecaptchaSiteKey();
  const debugToken = getFirebaseAppCheckDebugToken();

  if (debugToken && import.meta.env.DEV) {
    (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string }).FIREBASE_APPCHECK_DEBUG_TOKEN =
      debugToken;
  }

  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    appCheckInitialized = true;
    if (import.meta.env.DEV) {
      console.info('[Passport AppCheck] Initialized (monitor-only)');
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    if (message.includes('already initialized')) {
      appCheckInitialized = true;
      return;
    }
    console.warn('[Passport AppCheck] Initialization failed:', message);
  }
}

export function isFirebaseAppCheckInitialized(): boolean {
  return appCheckInitialized;
}
